import React, { useMemo } from 'react';
import { Link } from '@chakra-ui/react';
import { DiscordIcon } from '../../utils/icons/discord';
import { TwitterIcon } from '../../utils/icons/twitter';
import { TelegramIcon } from '../../utils/icons/telegram';
import { UrlIcon } from '../../utils/icons/url';
import { FacebookIcon } from '../../utils/icons/facebook';
import { InstagramIcon } from '../../utils/icons/instagram';
import { LinkedinIcon } from '../../utils/icons/linkedin';

enum Socials {
	DISCORD,
	TWITTER,
	YOUTUBE,
	URL,
	FACEBOOK,
	LINKEDIN,
	INSTAGRAM,
	TELEGRAM,
}

export interface ISocialsCircle {
	uri: string;
	name: string;
}

export const SocialsCircle = ({ data }: { data: ISocialsCircle }) => {
	const typeOptions: any = {
		[Socials.DISCORD]: <DiscordIcon />,
		[Socials.TWITTER]: <TwitterIcon />,
		[Socials.URL]: <UrlIcon />,
		[Socials.FACEBOOK]: <FacebookIcon />,
		[Socials.LINKEDIN]: <LinkedinIcon />,
		[Socials.INSTAGRAM]: <InstagramIcon />,
		[Socials.TELEGRAM]: <TelegramIcon />,
		[Socials.YOUTUBE]: null,
	};

	const connectType = useMemo(() => {
		return Socials[data.name.toUpperCase() as any];
	}, [data.name]);

	return (
		<Link
			display="flex"
			borderRadius="full"
			border="1px solid #FFFFFF1A"
			justifyContent="center"
			alignItems="center"
			width="32px"
			background="black"
			height="32px"
			_focus={{ boxShadow: 'none' }}
			target="_blank"
			href={data.uri}
			_hover={{ filter: 'invert(1)', background: 'black' }}
		>
			{typeOptions[connectType]}
		</Link>
	);
};
